import { render, staticRenderFns } from "./copyBomDetailBody.vue?vue&type=template&id=64768001&"
import script from "./copyBomDetailBody.vue?vue&type=script&lang=js&"
export * from "./copyBomDetailBody.vue?vue&type=script&lang=js&"
import style0 from "./copyBomDetailBody.vue?vue&type=style&index=0&id=64768001&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports